import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from "@angular/common";
// import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { SharedModule } from './app-shared/app-shared.module';

// Import Routes
import { AppRoutingModule } from './app-routing.module';

// Components
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { LoginComponent } from './login/login.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { LandingDashboardComponent } from './landing-dashboard/landing-dashboard.component';
import { PermissionNotFoundComponent } from './permission-not-found/permission-not-found.component';
import { IntermediatePageComponent } from './intermediate-page/intermediate-page.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SubdomainPrefrencesComponent } from './subdomain-prefrences/subdomain-prefrences.component';

// Kendo-UI Elements
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { LabelModule } from '@progress/kendo-angular-label';
import { EditorModule } from '@progress/kendo-angular-editor';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { PagerModule } from '@progress/kendo-angular-pager';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { GridModule } from '@progress/kendo-angular-grid';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { AuthenticationFailedComponent } from './authentication-failed/authentication-failed.component';




@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        LoginComponent,
        SideMenuComponent,
        LandingDashboardComponent,
        PermissionNotFoundComponent,
        NotFoundComponent,
        IntermediatePageComponent,
        BreadcrumbsComponent,
        SubdomainPrefrencesComponent,
        AuthenticationFailedComponent,
    ],
    exports: [SharedModule],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ], imports: [BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        SharedModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        // Kendo Elements
        ButtonsModule,
        InputsModule,
        TooltipModule,
        LabelModule,
        EditorModule,
        DropDownsModule,
        PagerModule,
        // AngularMultiSelectModule,
        ProgressBarModule,
        GridModule,
        DialogsModule], providers: [Title, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
